import {
  BaSeButton,
  BaSeHeading6,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useMessage } from '../../../../../hooks/messages/useMessage';
import { useInterviewService } from '../../../../../hooks/services/interview-service';

function ConfirmExtendDeadline({ idInterview, closeModal, reloadData }) {
  const { extendInterview } = useInterviewService();
  const { handleError, handleSuccess } = useMessage();
  const [loading, setLoading] = React.useState(false);

  const handleExpand = React.useCallback(() => {
    setLoading(true);
    extendInterview(idInterview)
      .then(() => {
        handleSuccess('Prazo prorrogado com sucesso.');
        closeModal();
        reloadData();
      })
      .catch((error) => {
        handleError(error.message ?? 'Erro ao prorrogar prazo.');
      })
      .finally(() => setLoading(false));
  }, [
    closeModal,
    extendInterview,
    handleError,
    handleSuccess,
    idInterview,
    reloadData,
  ]);

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <BaSeHeading6
        color={BaSeTheme.colors.feedbackInterface.atencao55}
        isBold={true}
      >
        Atenção!
      </BaSeHeading6>
      <BaSeParagraph>
        Tem certeza que deseja prorrogar em mais 15 dias o prazo de expiração
        dessa entrevista?
      </BaSeParagraph>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <BaSeButton
          color={BaSeTheme.colors.institucionais.azulSebrae10}
          value="Sim"
          onClick={handleExpand}
          isDisabled={loading}
        />

        <BaSeButton
          onClick={() => closeModal()}
          type="secondary"
          color={BaSeTheme.colors.institucionais.azulSebrae10}
          value="Não"
          isDisabled={loading}
        />
      </div>
    </div>
  );
}

export default ConfirmExtendDeadline;
